import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { DataTable } from "../DataTable/DataTable";
import { CreateCourseGroupModal } from "./CreateCourseGroupModal";
import { useQueryClient } from "@tanstack/react-query";
import { CourseGroupOrderCell } from "./CourseGroupOrderCell";
import { CourseGroup } from "../../../learner/types";
import { Link } from "react-router-dom";
import { REACT_APP_MANAGER_LINK } from "../../../utils";
import Button from "../../../student/components/generic/button";
import { COURSE_GROUPS_QUERY_KEY } from "./useCourseGroupsQuery";

export const CourseGroupsPage: React.FC = () => {
  useDocumentTitle("Course Groups");
  const queryClient = useQueryClient();

  const reloadGroups = () => {
    queryClient.invalidateQueries({ queryKey: [COURSE_GROUPS_QUERY_KEY] });
  };

  return (
    <main className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold">Course Groups</h1>
        <p>
          These are the groups that appear in the main course listing. You can
          add and reorder groups here. If you want to add courses to a group,
          you can do that in the{" "}
          <Link
            className="text-dm-brand-blue-500 hover:text-dm-brand-blue-800"
            to={`${REACT_APP_MANAGER_LINK}/course-builder`}
          >
            Course Builder
          </Link>
          .
        </p>
      </div>

      <DataTableContextProvider
        source="/manager_new/parent-portal/course-groups"
        queryKey={COURSE_GROUPS_QUERY_KEY}
        defaults={{ sortBy: [] }}
        downloadButton={false}
        fetchOnLoad
        columnOverrides={{
          order: ({ row, rows }) => (
            <CourseGroupOrderCell
              key={(row as any).original._id}
              rowIndex={(row as any).index}
              rows={(rows as unknown as any[]).map(
                ({ original }) => original as CourseGroup
              )}
              onReorder={reloadGroups}
            />
          ),
          edit: ({ row }) => (
            <CreateCourseGroupModal
              key={JSON.stringify((row as any).original)}
              onSave={reloadGroups}
              groupToEdit={(row as any).original as CourseGroup}
            >
              {(onClick) => (
                <Button type="link" onClick={onClick}>
                  Edit
                </Button>
              )}
            </CreateCourseGroupModal>
          ),
        }}
      >
        <CreateCourseGroupModal onSave={reloadGroups}>
          {(onClick) => (
            <Button onClick={onClick}>Create a New Course Group</Button>
          )}
        </CreateCourseGroupModal>
        <DataTable />
      </DataTableContextProvider>
    </main>
  );
};
